import { twMerge as e } from "tailwind-merge";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/components/field-feedback/index.tsx
function r({ className: r, description: i, descriptionClassName: a, error: o, errorClassName: s }) {
	let c = Array.isArray(o) ? o.length > 0 : !!o, l = typeof o == "string" || typeof o == "number" ? "p" : "div";
	return !i && !c ? null : /* @__PURE__ */ n("div", {
		className: e("grid gap-2", r),
		children: [i ? /* @__PURE__ */ t("span", {
			className: e("text-text-secondary text-sm", a),
			children: i
		}) : null, c ? /* @__PURE__ */ t(l, {
			className: e("text-text-error text-sm", s),
			children: o
		}) : null]
	});
}
//#endregion
export { r as FieldFeedback };
